import { Select } from '@blueprintjs/select';
import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  FormGroup,
  Label,
  MenuItem,
} from '@blueprintjs/core';
import { Dispatch, SetStateAction } from 'react';
import { FI as payoutTableFinland } from './payoutAndPremium';
import { insurance, loan_application } from '@axo/shared/data-access/types';
import { UseMutationResult } from 'react-query';
import { InsuranceLevel } from './InsuranceLevel.tsx';

export function PayoutAndPremiumDialog({
  updateAmount,
  setUpdateAmount,
  currency,
  disabled,
  latest: insurance,
  updateInsurance,
}: {
  updateAmount: number | null;
  setUpdateAmount: Dispatch<SetStateAction<number | null>>;
  currency: loan_application.Currency | null | undefined;
  disabled?: boolean;
  latest: insurance.Insurance;
  updateInsurance: UseMutationResult<
    insurance.Insurance,
    unknown,
    insurance.Insurance,
    unknown
  >;
}) {
  return (
    <Dialog
      isOpen={updateAmount !== null}
      onClose={() => setUpdateAmount(null)}
      icon="dollar"
      title="Update payout and premium"
    >
      <DialogBody>
        <FormGroup>
          <Label>Payout and premium</Label>
          <Select
            items={payoutTableFinland}
            disabled={disabled}
            itemRenderer={(level, { handleClick }) => (
              <MenuItem
                key={level.payout}
                selected={level.payout === updateAmount}
                text={InsuranceLevel({
                  amount: level.payout,
                  currency,
                })}
                onClick={handleClick}
              />
            )}
            onItemSelect={(value) => setUpdateAmount(value.payout)}
          >
            <Button
              fill
              id="insuranceAmount"
              disabled={disabled}
              rightIcon="caret-down"
              // @ts-expect-error Property 'placeholder' does not exist on type 'IntrinsicAttributes & ButtonSharedProps & ButtonHTMLAttributes<HTMLButtonElement> & RefAttributes<...>'.
              placeholder="Select amount"
              text={InsuranceLevel({
                amount: updateAmount ?? undefined,
                currency,
              })}
            />
          </Select>
        </FormGroup>
      </DialogBody>
      <DialogFooter
        actions={
          <Button
            intent="primary"
            text="Update"
            icon="floppy-disk"
            disabled={disabled || updateAmount === insurance.Amount}
            loading={updateInsurance.isLoading}
            onClick={async () => {
              if (updateAmount === null) return;

              await updateInsurance.mutateAsync({
                ...insurance,
                Amount: updateAmount,
              });
              setUpdateAmount(null);
            }}
          />
        }
      />
    </Dialog>
  );
}
